module.exports = __webpack_public_path__ + "static/media/phr_logo.30aecd96.png";